<template>
  <div class="mobile-columns" v-if="cards && cards.length">
    <div class="mobile-column-item" v-for="(card, i) in cards.slice(0, 3)" :key="`mc${i}`">
      <NuxtLink
        :to="{
          name: 'language-colunas-catergoriaId-categoriaName-colunaId-colunaName',
          params: {
            language: route.params.language,
            catergoriaId: card.idCategory,
            categoriaName: card.slugCategory,
            colunaId: card.id,
            colunaName: card.url,
          },
        }"
        class="mobile-column-item__image-link"
      >
        <img
          :src="card.image"
          class="mobile-column-item__image"
          :alt="card.title"
          width="105"
          height="90"
          loading="lazy"
        />
      </NuxtLink>
      <div class="mobile-column-item__content">
        <NuxtLink
          :to="{
            name: 'language-colunas-catergoriaId-categoriaName',
            params: {
              language: route.params.language,
              catergoriaId: card.idCategory,
              categoriaName: card.slugCategory,
            },
          }"
          class="mobile-column-item__tag-link"
        >
          <span class="mobile-column-item__tag">{{ card.nameCategory }}</span>
        </NuxtLink>
        <NuxtLink
          :to="{
            name: 'language-colunas-catergoriaId-categoriaName-colunaId-colunaName',
            params: {
              language: route.params.language,
              catergoriaId: card.idCategory,
              categoriaName: card.slugCategory,
              colunaId: card.id,
              colunaName: card.url,
            },
          }"
          class="mobile-column-item__title-link"
        >
          <h3 class="mobile-column-item__title">{{ card.title }}</h3>
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const route = useRoute();
defineProps<{ cards: any[] }>();
</script>

<style scoped>
.mobile-columns {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 0;
  background-color: #000000;
}

.mobile-column-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.mobile-column-item__image-link {
  flex: 0 0 auto;
  display: block;
}

.mobile-column-item__image {
  width: 105px;
  height: 90px;
  object-fit: cover;
  display: block;
}

.mobile-column-item__content {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.mobile-column-item__tag-link {
  align-self: flex-start;
  text-decoration: none;
}

.mobile-column-item__tag {
  display: inline-block;
  background-color: #b20000;
  color: #ffffff;
  font-family: "Roboto-Regular";
  font-size: 13px;
  padding: 5px 12px;
  border-radius: 20px;
  line-height: 1;
}

.mobile-column-item__title-link {
  text-decoration: none;
}

.mobile-column-item__title {
  color: #ffffff;
  font-family: "Roboto-Regular";
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  margin: 0;
}
</style>
